import React, { memo } from 'react';

import Loader from 'modules/views/shared/Loader';
import Wizard from 'modules/views/shared/Wizard';
import { useAppSelector } from 'modules/state-mgmt/store';
import { useWizardNavigation } from './hooks';

interface IWithWizardProps {
  stepTitle?: string;
  stepSubtitle?: string;
  content: React.ReactNode;
  fields?: Array<{ name: string; id: string; isRequired?: boolean; isSkippable?: boolean; skippableTill?: number }>;
  isLoading?: boolean;
  disableNavigation?: boolean;
  contentStyleClass?: string;
  showOnlineWarning?: boolean;
}

// Export navigation props interface for components to use
export interface WizardNavigationProps {
  goToNextStep: (skipSteps?: number) => void;
  goToPreviousStep: (skipSteps?: number) => void;
  handleNextStep: (event?: React.MouseEvent) => void;
  handlePreviousStep: (event?: React.MouseEvent) => void;
  navigateToStep: (stepIndex: number, subStepIndex?: number) => void;
  navigateToStepByKey: (stepKey: string, subStepKey?: string) => void;
  canGoToNextStep: boolean;
  canGoToPreviousStep: boolean;
  currentStepIndex: number;
  currentSubStepIndex: number;
}

const WithWizard = ({
  stepTitle,
  stepSubtitle,
  content,
  fields,
  isLoading,
  disableNavigation,
  contentStyleClass,
  showOnlineWarning,
}: IWithWizardProps) => {
  const { onboarding } = useAppSelector(state => ({
    onboarding: state.onboarding,
  }));

  // Use the custom hook for wizard navigation logic
  const { steps, currentStepIndex, onStepChange } = useWizardNavigation({
    stepTitle,
    content,
    fields,
  });

  return isLoading ? (
    <Loader />
  ) : (
    <Wizard
      steps={steps}
      sidebarTitle={onboarding.temp?.project?.label}
      sidebarSubtitle={
        onboarding.temp?.addEmployerFlow
          ? onboarding.temp?.employers?.map(e => e.label)?.join(', ')
          : onboarding.temp?.employers?.map(e => e.label)?.join(', ')
      }
      currentStepIndex={currentStepIndex}
      disableNavigation={disableNavigation}
      contentStyleClass={contentStyleClass}
      showOnlineWarning={showOnlineWarning}
      onStepChange={onStepChange}
    />
  );
};

export default memo(WithWizard);
